import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useOrderSave } from "../context/OrderSaveContext";
import { showErrorToast } from "../components/toasts/ToastService";

const TalpSarok = () => {
    const { order, updateOrder } = useOrder();
    const navigate = useStepNavigate();
    const [selectedTalpId, setSelectedTalpId] = useState(order.hmeliorder?.hmeliorder_cornertype_id || null);
    const [sarokMagassag, setSarokMagassag] = useState(order.hmeliorder?.hmeliorder_corner_height ?? null);
    const [soleType, setSoleType] = useState(
        (order.hmeliorder?.hmeliorder_sole_type || (order.hmeliorder?.hmeliorder_cornertype_id ? "epitett" : "")).toLowerCase()
    );
    const { saveOrder } = useOrderSave();
    const [loading, setLoading] = useState(false);

    const corner_types = order.model_options?.corner_types_for_model || [];
    const corner_heights = order.model_options?.corner_heights_for_model || [];

    const handleSoleTypeSelect = (type) => {
        const normalizedType = String(type || "").toLowerCase();
        setSoleType(normalizedType);

        updateOrder((prev) => ({
            ...prev,
            hmeliorder: {
                ...prev.hmeliorder,
                hmeliorder_sole_type: normalizedType,
                hmeliorder_sole_rama_id: 1,
                ...(normalizedType === "forma"
                    ? {
                          hmeliorder_cornertype_id: null,
                          hmeliorder_corner_type: "",
                          hmeliorder_corner_height: null,
                          hmeliorder_corner_height_id: null,
                      }
                    : {}),
            },
        }));

        if (normalizedType === "forma") {
            setSelectedTalpId(null);
            setSarokMagassag(null);
        }
    };

    const handleSelection = (type) => {
        if (soleType !== "epitett") return;

        setSelectedTalpId(type);
        updateOrder((prev) => ({
            ...prev,
            hmeliorder: {
                ...prev.hmeliorder,
                hmeliorder_cornertype_id: type,
                hmeliorder_corner_type:
                    (prev.model_options?.corner_types_for_model || []).find(
                        (t) => t.corner_type_szam === type
                    )?.corner_type_name || "",
            },
        }));
    };

    const handleSarokChange = (value) => {
        if (soleType !== "epitett") return;

        setSarokMagassag(value);
        updateOrder((prev) => ({
            ...prev,
            hmeliorder: {
                ...prev.hmeliorder,
                hmeliorder_corner_height: value,
                hmeliorder_corner_height_id:
                    (prev.model_options?.corner_heights_for_model || []).find(
                        (h) => h.corner_height_height === value
                    )?.corner_height_szam || null,
            },
        }));
    };

    const handleNext = async () => {
        setLoading(true);

        const cornerTypeName =
            soleType === "epitett"
                ? corner_types.find((t) => t.corner_type_szam === selectedTalpId)?.corner_type_name || ""
                : "";

        const cornerHeightId =
            soleType === "epitett"
                ? corner_heights.find((h) => h.corner_height_height === sarokMagassag)?.corner_height_szam || null
                : null;

        const updatedOrder = {
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
                hmeliorder_sole_type: soleType,
                hmeliorder_cornertype_id: soleType === "epitett" ? selectedTalpId : null,
                hmeliorder_corner_type: cornerTypeName,
                hmeliorder_corner_height: soleType === "epitett" ? sarokMagassag : null,
                hmeliorder_corner_height_id: cornerHeightId,
            },
        };

        try {
            updateOrder(updatedOrder);
            const result = await saveOrder(updatedOrder);

            if (result?.success !== false) {
                updateOrder((prev) => ({
                    ...prev,
                    hmeliorder: {
                        ...prev.hmeliorder,
                        hmeliorder_sole_type: soleType,
                        hmeliorder_cornertype_id: soleType === "epitett" ? selectedTalpId : null,
                        hmeliorder_corner_type: cornerTypeName,
                        hmeliorder_corner_height: soleType === "epitett" ? sarokMagassag : null,
                        hmeliorder_corner_height_id: cornerHeightId,
                    },
                }));
                navigate("/Talp");
            } else {
                showErrorToast(result?.message || "Hiba történt a rendelés mentése során!");
            }
        } catch (err) {
            showErrorToast("Hiba történt a rendelés mentése során: " + (err?.message || err));
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/OrrForma");
    };

    const canProceed =
        soleType === "forma"
            ? true
            : soleType === "epitett" && selectedTalpId > 1 && sarokMagassag !== null && sarokMagassag !== undefined && sarokMagassag !== "";

    return (
        <TablerLayout title="Adja meg a kívánt talp típust, sarok típust és a sarok magasságát!">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="card-body">
                        <div className="row g-3 justify-content-center mb-5">
                            <h5 className="text-center mb-2 fw-bold">Talp típusa</h5>
                            <div className="col-12 col-sm-6 col-lg-5">
                                <button
                                    type="button"
                                    className={"btn w-100 py-4 px-4 shadow-sm rounded-3 fw-bold " + (soleType === "forma" ? "btn-primary" : "btn-outline-primary text-primary border-primary bg-white")}
                                    style={{
                                                fontSize: 25,
                                                fontWeight: 600,
                                                borderWidth: 2,
                                                minHeight: 60,
                                            }}
                                    onClick={() => handleSoleTypeSelect("forma")}
                                    disabled={loading}
                                >
                                    Forma
                                </button>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-5">
                                <button
                                    type="button"
                                    className={"btn w-100 py-4 px-4 shadow-sm rounded-3 fw-bold " + (soleType === "epitett" ? "btn-primary" : "btn-outline-primary text-primary border-primary bg-white")}
                                    style={{
                                                fontSize: 25,
                                                fontWeight: 600,
                                                borderWidth: 2,
                                                minHeight: 60,
                                            }}
                                    onClick={() => handleSoleTypeSelect("epitett")}
                                    disabled={loading}
                                >
                                    Épített
                                </button>
                            </div>
                        </div>

                        <div className="row g-3 justify-content-center mb-4">
                            <h5 className="text-center mb-2 fw-bold">Sarok típusa</h5>
                            {corner_types.map((sarok) => (
                                <div className="col-12 col-sm-6 col-lg-4" key={sarok.corner_type_szam}>
                                    <button
                                        type="button"
                                        className={
                                            "btn w-100 py-3 px-2 shadow-sm rounded-3 fw-bold " +
                                            (
                                                selectedTalpId === sarok.corner_type_szam
                                                    ? "btn-primary"
                                                    : "btn-outline-primary text-primary border-primary bg-white"
                                            ) 
                                        }
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 600,
                                            borderWidth: 2,
                                            minHeight: 68,
                                            cursor: soleType !== "epitett" || sarok.disabled ? "not-allowed" : "pointer",
                                        }}
                                        onClick={() =>
                                            soleType === "epitett" &&
                                            !sarok.disabled &&
                                            handleSelection(sarok.corner_type_szam)
                                        }
                                        disabled={soleType !== "epitett" || sarok.disabled || loading}
                                        title={
                                            soleType !== "epitett"
                                                ? "Először válasszon talp típust: Épített"
                                                : sarok.disabled
                                                ? "Ez a talp/sarok típus nem elérhető ehhez a modellhez"
                                                : ""
                                        }
                                    >
                                        <span>{sarok.corner_type_name}</span>
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className="mt-5">
                            <h5 className="text-center mb-4 fw-bold">Sarok magassága</h5>
                            <div className="row g-3 justify-content-center">
                                {corner_heights.map((height) => (
                                    <div className="col-6 col-md-3" key={height.corner_height_szam}>
                                        <button
                                            type="button"
                                            className={
                                                "btn w-100 py-3 px-2 shadow-sm rounded-3 fw-bold " +
                                                (
                                                    sarokMagassag === height.corner_height_height
                                                        ? "btn-primary"
                                                        : "btn-outline-primary text-primary border-primary bg-white"
                                                )
                                            }
                                            style={{
                                                fontSize: 18,
                                                fontWeight: 600,
                                                borderWidth: 2,
                                                minHeight: 60,
                                                cursor: soleType !== "epitett" || height.disabled ? "not-allowed" : "pointer",
                                            }}
                                            onClick={() => handleSarokChange(height.corner_height_height)}
                                            disabled={soleType !== "epitett" || height.disabled || loading}
                                            title={
                                                soleType !== "epitett"
                                                    ? "Forma talpnál a sarok magasság nem választható"
                                                    : height.disabled
                                                    ? "Ez a sarok magasság nem elérhető ehhez a modellhez"
                                                    : ""
                                            }
                                        >
                                            {height.corner_height_height} cm
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBack} />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={handleNext}
                            disabled={!canProceed || loading}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default TalpSarok;
